export default "__VITE_ASSET__09dccf67__"